import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { getWalletData } from 'services/user';
import { RootState } from 'store';

interface BalanceState {
	balance: string;
};

const initialState: BalanceState = {
	balance: '',
};

export const fetchBalanceData = createAsyncThunk(
	'user/fetchBalanceData',
	async () => {
		const wallet = await getWalletData();
		return { balance: wallet.data };
	}
);

export const balanceSlice = createSlice({
	name: 'balance',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(fetchBalanceData.fulfilled, (state, action) => {
				const { balance } = action.payload;
				state.balance = balance.balanceSum;
			})
			.addCase(fetchBalanceData.rejected, (state) => {
				state.balance = '';
			})
	},
});

export const selectBalance = (state: RootState) => state.balance.balance;

export default balanceSlice.reducer;
